import React from "react"
import { ReactComponent as EyeIcon } from "@ciq/shared/assets/icons/map/eye_icon.svg"
import { ReactComponent as EyeShutIcon } from "@ciq/shared/assets/icons/map/eye_shut_icon.svg"
import { IconButton } from "@ciq/shared/components/buttons"
import { useFilterQueryParams } from "../../hooks/filter_query_params"

/**
 * Toggle button for showing/hiding building occupancy coloring on the map.
 * Displays an eye icon when occupancy is visible and a shut eye icon when hidden.
 */
export function OccupancyToggle() {
  const { isHidingOccupancy, toggleOccupancy } = useFilterQueryParams()

  const title = isHidingOccupancy ? "Show building occupancy" : "Hide building occupancy"
  const Icon = isHidingOccupancy ? EyeShutIcon : EyeIcon

  return (
    <div className="occupancy-toggle">
      <IconButton onClick={toggleOccupancy} title={title} aria-label={title}>
        <Icon />
      </IconButton>
    </div>
  )
}
